import {
  CONDITION_CATEGORY,
  CONDITION_CLINICIAL_STATUS,
  CONDITION_VERIFICATION_STATUS,
  ELATION_CONDITION_CLINICAL_STATUS,
} from '#src/codeSystems.ts'

export const ConditionCategory = {
  DIAGNOSIS: 'diagnosis',
  CARE_PLAN_PROBLEM: 'care-plan-problem',
} as const
export type ConditionCategory =
  (typeof ConditionCategory)[keyof typeof ConditionCategory]

export const CONDITION_CATEGORIES = {
  [ConditionCategory.DIAGNOSIS]: {
    system: CONDITION_CATEGORY,
    code: ConditionCategory.DIAGNOSIS,
    display: 'Diagnosis',
  },
  [ConditionCategory.CARE_PLAN_PROBLEM]: {
    system: CONDITION_CATEGORY,
    code: ConditionCategory.CARE_PLAN_PROBLEM,
    display: 'Care Plan Problem',
  },
} as const

// https://terminology.hl7.org/6.1.0/CodeSystem-condition-clinical.html
export const ConditionClinicalStatus = {
  ACTIVE: 'active',
  RECURRENCE: 'recurrence',
  RELAPSE: 'relapse',
  INACTIVE: 'inactive',
  REMISSION: 'remission',
  RESOLVED: 'resolved',
  UNKNOWN: 'unknown',
  CONTROLLED: 'controlled',
} as const
export type ConditionClinicalStatus =
  (typeof ConditionClinicalStatus)[keyof typeof ConditionClinicalStatus]

export const CONDITION_CLINICAL_STATUSES = {
  [ConditionClinicalStatus.ACTIVE]: {
    system: CONDITION_CLINICIAL_STATUS,
    code: ConditionClinicalStatus.ACTIVE,
    display: 'Active',
  },
  [ConditionClinicalStatus.RECURRENCE]: {
    system: CONDITION_CLINICIAL_STATUS,
    code: ConditionClinicalStatus.RECURRENCE,
    display: 'Recurrence',
  },
  [ConditionClinicalStatus.RELAPSE]: {
    system: CONDITION_CLINICIAL_STATUS,
    code: ConditionClinicalStatus.RELAPSE,
    display: 'Relapse',
  },
  [ConditionClinicalStatus.INACTIVE]: {
    system: CONDITION_CLINICIAL_STATUS,
    code: ConditionClinicalStatus.INACTIVE,
    display: 'Inactive',
  },
  [ConditionClinicalStatus.REMISSION]: {
    system: CONDITION_CLINICIAL_STATUS,
    code: ConditionClinicalStatus.REMISSION,
    display: 'Remission',
  },
  [ConditionClinicalStatus.RESOLVED]: {
    system: CONDITION_CLINICIAL_STATUS,
    code: ConditionClinicalStatus.RESOLVED,
    display: 'Resolved',
  },
  [ConditionClinicalStatus.UNKNOWN]: {
    system: CONDITION_CLINICIAL_STATUS,
    code: ConditionClinicalStatus.UNKNOWN,
    display: 'Unknown',
  },
  [ConditionClinicalStatus.CONTROLLED]: {
    system: ELATION_CONDITION_CLINICAL_STATUS,
    code: ConditionClinicalStatus.CONTROLLED,
    display: 'Controlled',
  },
} as const

// http://terminology.hl7.org/CodeSystem/condition-ver-status
export const ConditionVerificationStatus = {
  UNCONFIRMED: 'unconfirmed',
  PROVISIONAL: 'provisional',
  DIFFERENTIAL: 'differential',
  CONFIRMED: 'confirmed',
  REFUTED: 'refuted',
  ENTERED_IN_ERROR: 'entered-in-error',
} as const
export type ConditionVerificationStatus =
  (typeof ConditionVerificationStatus)[keyof typeof ConditionVerificationStatus]

export const CONDITION_VERIFICATION_STATUSES = {
  [ConditionVerificationStatus.UNCONFIRMED]: {
    system: CONDITION_VERIFICATION_STATUS,
    code: ConditionVerificationStatus.UNCONFIRMED,
    display: 'Unconfirmed',
  },
  [ConditionVerificationStatus.PROVISIONAL]: {
    system: CONDITION_VERIFICATION_STATUS,
    code: ConditionVerificationStatus.PROVISIONAL,
    display: 'Provisional',
  },
  [ConditionVerificationStatus.DIFFERENTIAL]: {
    system: CONDITION_VERIFICATION_STATUS,
    code: ConditionVerificationStatus.DIFFERENTIAL,
    display: 'Differential',
  },
  [ConditionVerificationStatus.CONFIRMED]: {
    system: CONDITION_VERIFICATION_STATUS,
    code: ConditionVerificationStatus.CONFIRMED,
    display: 'Confirmed',
  },
  [ConditionVerificationStatus.REFUTED]: {
    system: CONDITION_VERIFICATION_STATUS,
    code: ConditionVerificationStatus.REFUTED,
    display: 'Refuted',
  },
  [ConditionVerificationStatus.ENTERED_IN_ERROR]: {
    system: CONDITION_VERIFICATION_STATUS,
    code: ConditionVerificationStatus.ENTERED_IN_ERROR,
    display: 'Entered in Error',
  },
} as const
